module.exports = __webpack_public_path__ + "img/TECNOLOGIA-IGNIS-1.12d08ad6.jpg";